import globalActions from "../api/GlobalActions.js"
import globalMutations from "../api/GlobalMutations.js"
import globalGetters from "../api/GlobalGetters.js"

export const state = () => ({
  isStale: true,
  latest_fetch: "",
  type: "dailycfsFilters",
  pageLayout: "StructureTable",
  canEdit: false,
  canView: false,
  effectedByYear: false,
  yearFields: [],
  filterOverrides: ["audits"],
  aliasField: "name",
  modelLabels: {
    single: "Filter",
    plural: "Filters"
  },
  relations: [
    // {
    //   name: "maintenanceRequests",
    //   translate: "maintenanceRequests",
    //   value: "maintenanceRequests",
    //   storename: "maintenanceRequests",
    //   yearFields: []
    // },
    // {
    //   name: "owners",
    //   translate: "owners",
    //   value: "owners",
    //   label: "Owners",
    //   storename: "contacts",
    //   yearFields: []
    // },
    // {
    //   name: "producers",
    //   translate: "producers",
    //   value: "producers",
    //   label: "Producers",
    //   storename: "contacts",
    //   yearFields: []
    // }
  ],
  all: {},
  reference: {
    /* for showing paginated resources ... needs a bit more work. */
  },
  active: false,
  page: 1,
  pageCount: 0,
  pagination: {
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    itemsPerPage: 150,
    sort: true,
    sortBy: "created_at",
    page: 1,
    sortDesc: []
  },
  print_path: "",
  search: null,
  searchFields: [],
  total: 0,
  print: false,
  export: false,
  bound: {},
  filter: {},
  quickFilters: [],
  stub: {
    canal: {},
    user: {}
  },
  // members are called contractors on the server
  include: "",
  headers: {},
  notifications: {}
})

// Mutations ==================

export const mutations = {
  ...globalMutations
}

// Actions ====================

export const actions = {
  ...globalActions
}

// Getters ====================

export const getters = {
  ...globalGetters
}
